module.exports = "../../app/cells/components/offers/stamp_cell.rb";